import { ExternalLinkIcon } from '@chakra-ui/icons';
import { Flex, Text, Link } from '@chakra-ui/react';

function Footer() {
  return (
    <Flex ml={{ base: 0, md: 20 }} p={10} justify="right">
      <Text>
        Copyright © {new Date().getFullYear()} TrendAI™ All rights reserved -
        v1.9.5-beta -{' '}
        <Link
          href="https://trendmicro.atlassian.net/wiki/spaces/SQK/pages/2419621900/1200.12+-+Release+Notes+-+v1.9.5-beta"
          isExternal
        >
          All Release Notes <ExternalLinkIcon mx="2px" />
        </Link>
      </Text>
    </Flex>
  );
}

export default Footer;
